import { ITabKeySetAction } from './types';
import { AT_TAB_KEY_SET } from './constants';

export const tabKeySetAction = (
    tabKey: string
): ITabKeySetAction => ({
    type: AT_TAB_KEY_SET,
    tabKey
});
